import React, { Component } from 'react';
import { message } from 'antd';
import MachineLogAddView from '../views/MachineLogAddView';
import { base } from '../../base';

class MachineLogAddContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            log: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.logId = this.props.logId;
        this.logRef = null;
    }

    componentDidMount() {
        if (this.logId) {
            this.logRef = base.syncState(`logs/${this.props.extraUser.companyid}/${this.logId}`, {
                context: this,
                state: 'log',
            });
        }
    }

    componentWillUnmount() {
        if (this.logRef != null) {
            base.removeBinding(this.logRef);
        }
    }

    handleSubmit(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const logId = this.props.logId;

        if (logId) {
            this.handleUpdate(values);
        } else {
            const { closeForm } = this.props;
            if (values.type === 'Otro') {
                base.push(`logs/${this.props.extraUser.companyid}/`, {
                    data: {
                        author: extraUser.key,
                        machineid: machineId,
                        time: (new Date()).getTime(),
                        type: values.other,
                        description: values.description,
                        location: values.location,
                        cost: values.cost,
                    },
                    then(err) {
                        if (!err) {
                            message.success('Bitacora agregada exitosamente');
                            closeForm();
                        }
                    },
                });
            } else {
                base.push(`logs/${this.props.extraUser.companyid}/`, {
                    data: {
                        author: extraUser.key,
                        machineid: machineId,
                        time: (new Date()).getTime(),
                        type: values.type,
                        description: values.description,
                        location: values.location,
                        cost: values.cost,
                    },
                    then(err) {
                        if (!err) {
                            message.success('Bitacora agregada exitosamente');
                            closeForm();
                        }
                    },
                });
            }
        }
    }

    handleUpdate(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const logId = this.props.logId;
        const { closeForm } = this.props;
        base.update(`logs/${this.props.extraUser.companyid}/${logId}`, {
            data: {
                author: extraUser.key,
                machineid: machineId,
                time: (new Date()).getTime(),
                type: values.type,
                description: values.description,
                location: values.location,
                cost: values.cost,
            },
            then(err) {
                if (!err) {
                    message.success('Bitacora Editada exitosamente');
                    closeForm();
                }
            },
        });
    }

    render() {
        return (
            <MachineLogAddView
                log={this.state.log}
                openForm={this.props.openForm}
                onCancel={this.props.onCancel}
                closeForm={this.props.closeForm}
                handleSubmit={this.handleSubmit}
            />
        );
    }
}

export default MachineLogAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineLogAddContainer.js